export { default as VictoryChart } from "./victory-chart";


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/es/index.js
// module id = ./node_modules/victory-chart/es/index.js
// module chunks = 1